type LoadingSetter = (loading: boolean) => void;

class LoadingControllerClass {
  private setLoading: LoadingSetter | null = null;
  private forcedLoading = false;

  register(setter: LoadingSetter) {
    this.setLoading = setter;
  }

  unregister() {
    this.setLoading = null;
  }

  show() {
    this.setLoading?.(true);
  }

  hide() {
    !this.forcedLoading && this.setLoading?.(false);
  }

  forceShow() {
    this.forcedLoading = true;
    this.setLoading?.(true);
  }

  forceHide() {
    this.forcedLoading = false;
    this.setLoading?.(false);
  }

  isForcedLoading() {
    return this.forcedLoading;
  }
}

export const LoadingController = new LoadingControllerClass();
